var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"map"}}),(!!this.google && !!this.map)?[_c('map-provider',{attrs:{"google":_vm.google,"map":_vm.map}},[_vm._t("default")],2)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }